import axios from 'axios'

import { ERROR_MESSAGE_SAVING } from '../constants'
import { handleRequestError } from './request'

export const REQUEST_REFERREDBY = 'REQUEST_REFERREDBY'
export const RECEIVE_REFERREDBY = 'RECEIVE_REFERREDBY'

export const getReferredBy = () => (dispatch, getState) => {
    dispatch({ type: REQUEST_REFERREDBY })

    const { profile } = getState()

    const { id: userId } = profile

    return axios
        .get(`/users/${userId}/referredby`)
        .then((response) => {
            const data = response?.data || {}
            dispatch({ type: RECEIVE_REFERREDBY })
            dispatch(receiveReferredBy({ ...data, fetchSuccessful: true }))
        })
        .catch((error) => {
            if (error?.status === 404) {
                dispatch(receiveReferredBy({ fetchSuccessful: true }))
                return
            }

            dispatch(handleRequestError(error, { customMessage: ERROR_MESSAGE_SAVING }))
        })
}

export const receiveReferredBy = (data) => ({ type: RECEIVE_REFERREDBY, data })
